import React from 'react'
import uniqid from 'uniqid'
import './Style.css'

const ExperienceContainer = ({ experience }) => (
  <div className='experience-card'>
    <h3>{experience.role}</h3>
    <h5>{experience.company}</h5>
    <p className='experience__details'>
      {experience.duration} {experience.location}
    </p>
    <p className='experience__description'>{experience.description}</p>
    <ul className='experience__responsibilities'>
      {experience.responsibilities.map((item) => (
        <li key={uniqid()}>{item}</li>
      ))}
    </ul>

    <ul className='stack'>
      {experience.technologies.map((tech) => (
        <li key={uniqid()} className='stack-item'>
          {tech}
        </li>
      ))}
    </ul>
    <a
      href={experience.companyUrl}
      aria-label='company website'
      className='link link--icon'
    />
  </div>
)

export default ExperienceContainer
